import { PopularSearchItem } from './index'
import { getLanguageFromLocale } from '../../../i18n/utils'

/**
 * Popular searches data using actual Topic enum IDs
 * Each entry represents a Topic + Country combination
 *
 */

export const POPULAR_SEARCHES_DE: PopularSearchItem[] = [
    {
        id: 'pool-germany',
        icon: '/assets/images/popular-search/pool.jpg',
        label: 'Schwimmbad',
        country: 'Deutschland',
        url: '/urlaubsideen/poolhaeuser/europa/deutschland/2-personen/ergebnisse/',
    },
    {
        id: 'ski-holiday-germany',
        icon: '/assets/images/popular-search/skiing.jpg',
        label: 'Skifahren',
        country: 'Deutschland',
        url: '/urlaubsideen/skiurlaub/europa/deutschland/2-personen/ergebnisse/',
    },
    {
        id: 'mountains-austria',
        icon: '/assets/images/popular-search/mountain.jpg',
        label: 'Berge',
        country: 'Österreich',
        url: '/urlaubsideen/in-den-bergen/europa/oesterreich/2-personen/ergebnisse/',
    },
    {
        id: 'dog-friendly-germany',
        icon: '/assets/images/popular-search/pet.jpg',
        label: 'Urlaub mit Hund',
        country: 'Deutschland',
        url: '/urlaubsideen/urlaub-mit-hund/europa/deutschland/2-personen/ergebnisse/',
    },
    {
        id: 'beaches-spain',
        icon: '/assets/images/popular-search/beach.jpg',
        label: 'Strände',
        country: 'Spanien',
        url: '/urlaubsideen/strandurlaub/europa/spanien/2-personen/ergebnisse/',
    },
    {
        id: 'pool-spain',
        icon: '/assets/images/popular-search/pool.jpg',
        label: 'Schwimmbad',
        country: 'Spanien',
        url: '/urlaubsideen/poolhaeuser/europa/spanien/2-personen/ergebnisse/',
    },
    {
        id: 'wellness-germany',
        icon: '/assets/images/popular-search/wellness.jpg',
        label: 'Wellness-Retreats',
        country: 'Deutschland',
        url: '/urlaubsideen/wellness/europa/deutschland/2-personen/ergebnisse/',
    },
    {
        id: 'ski-holiday-austria',
        icon: '/assets/images/popular-search/skiing.jpg',
        label: 'Skifahren',
        country: 'Österreich',
        url: '/urlaubsideen/skiurlaub/europa/oesterreich/2-personen/ergebnisse/',
    },
    {
        id: 'sauna-germany',
        icon: '/assets/images/popular-search/sauna.jpg',
        label: 'Sauna',
        country: 'Deutschland',
        url: '/europa/deutschland/mit-sauna/2-personen/ergebnisse/',
    },
    {
        id: 'pet-friendly-italy',
        icon: '/assets/images/popular-search/pet.jpg',
        label: 'Haustierfreundlich',
        country: 'Italien',
        url: '/urlaubsideen/urlaub-mit-haustier/europa/italien/2-personen/ergebnisse/',
    },
    {
        id: 'lake-view-italy',
        icon: '/assets/images/popular-search/lakeview.jpg',
        label: 'Seeblick',
        country: 'Italien',
        url: '/urlaubsideen/am-see/europa/italien/2-personen/ergebnisse/',
    },
    {
        id: 'air-conditioning-italy',
        icon: '/assets/images/popular-search/aircondition.jpg',
        label: 'Klimaanlage',
        country: 'Italien',
        url: '/europa/italien/2-personen/ergebnisse/?feat_ids=11',
    },
    {
        id: 'holiday-with-dog-spain',
        icon: '/assets/images/popular-search/pet.jpg',
        label: 'Urlaub mit Hund',
        country: 'Spanien',
        url: '/urlaubsideen/urlaub-mit-hund/europa/spanien/2-personen/ergebnisse/',
    },
    {
        id: 'air-conditioning-spain',
        icon: '/assets/images/popular-search/aircondition.jpg',
        label: 'Klimaanlage',
        country: 'Spanien',
        url: '/europa/spanien/2-personen/ergebnisse/?feat_ids=11',
    },
    {
        id: 'beaches-germany',
        icon: '/assets/images/popular-search/beach.jpg',
        label: 'Strände',
        country: 'Deutschland',
        url: '/urlaubsideen/strandurlaub/europa/deutschland/2-personen/ergebnisse/',
    },
]

// UK English - Translated from German content
export const POPULAR_SEARCHES_EN_GB: PopularSearchItem[] = [
    {
        id: 'pool-germany',
        icon: '/assets/images/popular-search/pool.jpg',
        label: 'Swimming pool',
        country: 'Germany',
        url: '/europa/deutschland/mit-pool/2-personen/ergebnisse/',
    },
    {
        id: 'ski-holiday-germany',
        icon: '/assets/images/popular-search/skiing.jpg',
        label: 'Skiing',
        country: 'Germany',
        url: '/urlaubsideen/skiurlaub/europa/deutschland/2-personen/ergebnisse/',
    },
    {
        id: 'mountains-austria',
        icon: '/assets/images/popular-search/mountain.jpg',
        label: 'Mountains',
        country: 'Austria',
        url: '/urlaubsideen/in-den-bergen/europa/oesterreich/2-personen/ergebnisse/',
    },
    {
        id: 'dog-friendly-germany',
        icon: '/assets/images/popular-search/pet.jpg',
        label: 'Holiday with dog',
        country: 'Germany',
        url: '/urlaubsideen/urlaub-mit-hund/europa/deutschland/2-personen/ergebnisse/',
    },
    {
        id: 'beaches-spain',
        icon: '/assets/images/popular-search/beach.jpg',
        label: 'Beaches',
        country: 'Spain',
        url: '/urlaubsideen/strandurlaub/europa/spanien/2-personen/ergebnisse/',
    },
    {
        id: 'pool-spain',
        icon: '/assets/images/popular-search/pool.jpg',
        label: 'Swimming pool',
        country: 'Spain',
        url: '/urlaubsideen/poolhaeuser/europa/spanien/2-personen/ergebnisse/',
    },
    {
        id: 'wellness-germany',
        icon: '/assets/images/popular-search/wellness.jpg',
        label: 'Wellness retreats',
        country: 'Germany',
        url: '/urlaubsideen/wellness/europa/deutschland/2-personen/ergebnisse/',
    },
    {
        id: 'ski-holiday-austria',
        icon: '/assets/images/popular-search/skiing.jpg',
        label: 'Skiing',
        country: 'Austria',
        url: '/urlaubsideen/skiurlaub/europa/oesterreich/2-personen/ergebnisse/',
    },
    {
        id: 'sauna-germany',
        icon: '/assets/images/popular-search/sauna.jpg',
        label: 'Sauna',
        country: 'Germany',
        url: '/urlaubsideen/sauna/europa/deutschland/2-personen/ergebnisse/',
    },
    {
        id: 'pet-friendly-italy',
        icon: '/assets/images/popular-search/pet.jpg',
        label: 'Pet friendly',
        country: 'Italy',
        url: '/urlaubsideen/urlaub-mit-haustier/europa/italien/2-personen/ergebnisse/',
    },
    {
        id: 'lake-view-italy',
        icon: '/assets/images/popular-search/lakeview.jpg',
        label: 'Lake view',
        country: 'Italy',
        url: '/urlaubsideen/am-see/europa/italien/2-personen/ergebnisse/',
    },
    {
        id: 'air-conditioning-italy',
        icon: '/assets/images/popular-search/aircondition.jpg',
        label: 'Air conditioning',
        country: 'Italy',
        url: '/urlaubsideen/klimaanlage/europa/italien/2-personen/ergebnisse/',
    },
    {
        id: 'air-conditioning-spain',
        icon: '/assets/images/popular-search/aircondition.jpg',
        label: 'Air conditioning',
        country: 'Spain',
        url: '/urlaubsideen/klimaanlage/europa/spanien/2-personen/ergebnisse/',
    },
    {
        id: 'pool-only-spain',
        icon: '/assets/images/popular-search/pool.jpg',
        label: 'Swimming pool',
        country: 'Spain',
        url: '/urlaubsideen/mit-pool/europa/spanien/2-personen/ergebnisse/',
    },
    {
        id: 'beaches-germany',
        icon: '/assets/images/popular-search/beach.jpg',
        label: 'Beaches',
        country: 'Germany',
        url: '/urlaubsideen/strandurlaub/europa/deutschland/2-personen/ergebnisse/',
    },
]

// US English (same as UK for now, can be customized)
export const POPULAR_SEARCHES_EN_US: PopularSearchItem[] = POPULAR_SEARCHES_EN_GB

export const getPopularSearchesByLocale = (locale: string): PopularSearchItem[] => {
    const normalizedLocale = getLanguageFromLocale(locale)

    switch (normalizedLocale) {
        case 'en_GB':
            return POPULAR_SEARCHES_EN_GB

        case 'en_US':
            return POPULAR_SEARCHES_EN_US

        case 'de_DE':
        default:
            return POPULAR_SEARCHES_DE
    }
}
